import { useEffect } from 'react';
import OwnerInfoField from 'src/components/PropertyOwnerInfo/OwnerInfoField';
import Address from 'src/components/util/Address';
import Section from 'src/components/util/Section';
import Subheader from 'src/components/util/Subheader';
import ADDRESS_FIELD_NAMES from 'src/data/propertyOwnerInfo/addressFieldNames';

/**
 * @returns {JSX.Element} 				- The Property owner information component.
 */

export default function PropertyOwnerInformation({ setDisableNext = () => {} }) {
  useEffect(() => {
    setDisableNext(false);
  }, [setDisableNext]);

  return (
    <Section title="Property Owner Information">
      <p>
        This application requests personal data to process and complete the service requested. The
        information provided will be used only to verify eligibility and deliver the requested
        service. If the requested information is not provided, the service may be delayed or may not
        be completed. Personal data may be shared with authorized Utah County departments, state
        agencies as required to complete the service.
      </p>
      <Subheader>Contact</Subheader>
      <OwnerInfoField />

      <Subheader>Address</Subheader>
      <Address fieldNames={ADDRESS_FIELD_NAMES} />
    </Section>
  );
}
